import React from 'react';

import styles from './ShellBar.module.css';

function Divider() {
  return <span className={styles.divider}>|</span>;
}

export default Divider;
